<template>
  <transition name="fade">
    <div v-if="notification" :class="['notification', notification.type]">
      <div class="notification-content">
        {{ notification.message }}
      </div>
      <button @click="clearNotification" class="close-button">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </transition>
</template>

<script>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Notification',
  
  setup() {
    const store = useStore()
    
    const notification = computed(() => store.state.notification)
    
    const clearNotification = () => {
      store.commit('CLEAR_NOTIFICATION')
    }
    
    // Auto-clear notification after 5 seconds when notification changes
    watch(notification, (newVal) => {
      if (newVal) {
        setTimeout(() => {
          clearNotification()
        }, 5000)
      }
    })
    
    return {
      notification,
      clearNotification
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 300px;
  max-width: 400px;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  &.success {
    background-color: #d4edda;
    color: #155724;
    border-left: 4px solid #28a745;
  }
  
  &.error {
    background-color: #f8d7da;
    color: #721c24;
    border-left: 4px solid #dc3545;
  }
  
  &.info {
    background-color: #d1ecf1;
    color: #0c5460;
    border-left: 4px solid #17a2b8;
  }
  
  &.warning {
    background-color: #fff3cd;
    color: #856404;
    border-left: 4px solid #ffc107;
  }
  
  .notification-content {
    flex: 1;
    margin-right: 10px;
  }
  
  .close-button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: 16px;
    opacity: 0.7;
    
    &:hover {
      opacity: 1;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style> 